

import React, { useState } from "react";
import { Table } from "antd";
import styles from "./Equipment.module.css";
import { useNavigate } from "react-router-dom";
import { Dropdown, Modal, SubmitButton, TextComponent } from "../../../components";
import HeaderComponent from "../../../components/HeaderComponent/HeaderComponent";

const EquipmentManagement = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filterModal, setFilterModal] = useState(false)
  const [station, setStation] = useState({
    value: "station",
    role: "station",
    id: 1,
  });
  const [machineType, setMachineType] = useState({
    value: "Machine Type",
    role: "Machine Type",
    id: 1,
  });


  const [staffList] = useState([
    {
      no: "1.",
      equipmentName: "Stand mixers",
      station: "Mixing",
      MachineType: "Automatic",
      maintenanceDue: "Aug 31, 2025",
      status: "Active",
      action: "View",
    },
    {
      no: "2.",
      equipmentName: "Proofing cabinet",
      station: "Oven",
      MachineType: "Manual",
      maintenanceDue: "Aug 15, 2025",
      status: "Active",
      action: "Edit",
    },
    {
      no: "3.",
      equipmentName: "Microwave oven",
      station: "Oven",
      maintenanceDue: "Feb 15, 2025",
      MachineType: "Automatic",
      status: "Archived",
      action: "Archive",
    },
    {
      no: "4.",
      equipmentName: "Dough sheeter",
      station: "Mixing",
      MachineType: "Manual",
      maintenanceDue: "Nov 15, 2025",
      status: "Archived",
      action: "Archive",
    },
    {
      no: "5.",
      equipmentName: "Fondant tools",
      station: "Oven",
      MachineType: "Automatic",
      maintenanceDue: "Oct 15, 2025",
      status: "Active",
      action: "View",
    },
    {
      no: "6.",
      equipmentName: "Measuring cups & spoons",
      station: "Mixing",
      MachineType: "Manual",
      maintenanceDue: "Sep 15, 2025",
      status: "Archived",
      action: "View",
    },
  ]);

  const columns = [
    // {
    //   title: "No.",
    //   dataIndex: "no",
    //   key: "no",
    //   render: (text) => (
    //     <TextComponent className={styles.materialText} text={`${text}`} />
    //   ),
    // },
    {
      title: "Equipment",
      dataIndex: "equipmentName",
      key: "equipmentName",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Category",
      dataIndex: "station",
      key: "station",
      render: (text) => (
        <TextComponent className={styles.materialText} text={text} />
      ),
    },
    {
      title: "Maintenance",
      dataIndex: "maintenanceDue",
      key: "maintenanceDue",
      render: (text) => (
        <TextComponent className={styles.materialText} text={text} />
      ),
    },
    {
      title: "Machine Type",
      dataIndex: "MachineType",
      key: "MachineType",
      render: (text) => (
        <TextComponent className={styles.materialText} text={text} />
      ),
    },
    {
      title: "",
      key: "button",
      render: (_, record) => (
        <SubmitButton
          title={"View"}
          btnClass={styles.tableBtn}
          primary
          // onClick={() => {
          //   navigate(`/supervisor/EquipmentDetails`);
          // }}
          onClick={() => {
            navigate(`/supervisor/EquipmentDetails?machineType=${record.MachineType}`);
          }}
        />

      ),
    },
  ];


  const stationOpt = [

    {
      value: "station",
      role: "station",
      id: 1,
    },
    {
      value: "Mixing",
      role: "Mixing",
      id: 2,
    },
    {
      value: "Make Up",
      role: "Make Up",
      id: 3,
    },
    {
      value: "Proofing",
      role: "Proofing",
      id: 4,
    }, {
      value: "Chill",
      role: "Chill",
      id: 5,
    }, {
      value: "Oven",
      role: "Oven",
      id: 6,
    }, {
      value: "Assembly",
      role: "Assembly",
      id: 7,
    }, {
      value: "Packaging",
      role: "Packaging",
      id: 8,
    },
  ]
  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Equipment"}
        onSearch={(e) => setSearchTerm(e.target.value)}
        onSubmit={() => navigate("/AddEquipment")}
        // submitButtonText={"Add Equipment"}
        headingStyle={styles.headingStyle}
        rightControlsStyle={styles.rightControlsStyle}
        showFilterIcon={true}
        showSubmitButton={false}
        showSearch={true}
        onClickFilter={() => setFilterModal(true)}
      />

      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={staffList}
          pagination={false}
          rowKey="no"
        />
      </div>


      {/* //////////////////// Filters ////////////////////// */}

      <Modal
        open={filterModal}
        onCancel={() => {
          setFilterModal(false);
        }}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Apply Filters(1)"}
        cancelBtnTitle={"Reset All"}
        onClickCancelButton={() => setFilterModal(false)}
        onClickOkButton={() => {
          setFilterModal(false)
        }}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <Dropdown
          // label={"Stations"}
          // labelClass={styles.DropDownLabel}
          value={station}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={stationOpt}
          onChange={(e) => setStation(e)}
        />

        <Dropdown
          // label={"Machine Type"}
          // labelClass={styles.DropDownLabel}
          value={machineType}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Machine Type",
              role: "Machine Type",
              id: 1,
            },
            {
              value: "Automatic",
              role: "Automatic",
              id: 2,
            },
            {
              value: "Manual",
              role: "Manual",
              id: 3,
            },
          ]}
          onChange={(e) => setMachineType(e)}
        />
      </Modal>
    </div>
  );
};

export default EquipmentManagement;
